import React from 'react';
import Typography from '@material-ui/core/Typography';
import { NO_STORE } from '../messages';

export default function NoStore() {
  return <Typography>{NO_STORE}</Typography>;
}
